import React from 'react';

function CreditMemoDetails() {
    return (
        <div>not done yet either lol</div>
    );
}

export default CreditMemoDetails;